<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="4">
        <div class="btn-group-lg btn-group-horizontal">
          <!-- <b-col sm="6" lg="3"> -->
          <b-button variant="success active" class="myLargeButton" @click="DashRouteTo('expedite')">
            <h5>
              <i class="fa fa-fighter-jet" />
              Expedited Shipping Request
            </h5>
          </b-button>
        </div>
      </b-col>
      <b-col lg="4">
        <div class="btn-group-lg btn-group-horizontal">
          <!-- </b-col> -->
          <!-- <b-col sm="6" lg="3"> -->
          <b-button variant="info active" class="myLargeButton" @click="DashRouteTo('orders')">
            <h5>
              <i class="fa fa-dropbox"></i>
              One-Time Order Status & History
            </h5>
          </b-button>
        </div>
      </b-col>
      <b-col lg="4">
        <div class="btn-group-lg btn-group-horizontal">
          <!-- </b-col> -->
          <!-- <b-col sm="6" lg="3"> -->
          <b-button
            variant="orange active"
            class="myLargeButton"
            @click="DashRouteTo('client-direct')"
          >
            <h5>
              <i class="fa fa-envelope-open" />
              Client Direct History
            </h5>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="isAdmin" lg="4">
        <div class="btn-group-lg btn-group-horizontal">
          <!-- </b-col> -->
          <!-- <b-col sm="6" lg="3"> -->
          <b-button
            variant="darkred active "
            class="myLargeButton"
            @click="DashRouteTo('production')"
          >
            <h5>
              <i class="fa fa-simplybuilt fa-flip-horizontal" />
              Production Status & History
            </h5>
          </b-button>
        </div>
      </b-col>
      <b-col v-if="isAdmin" lg="4">
        <div class="btn-group-lg btn-group-horizontal">
          <!-- </b-col> -->
          <!-- <b-col sm="6" lg="3"> -->
          <b-button
            variant="deeppurple active "
            class="myLargeButton"
            @click="DashRouteTo('shipping')"
          >
            <h5>
              <i class="fa fa-truck fa-flip-horizontal" />
              Shipping Status & History
            </h5>
          </b-button>
        </div>
      </b-col>
    <b-col v-if="canTrack" lg="4">
        <div class="btn-group-lg btn-group-horizontal">
          <!-- </b-col> -->
          <!-- <b-col sm="6" lg="3"> -->
          <b-button 
            variant="deepbrown active "
            class="myLargeButton"
          >
            <h5>
              <a class="solidWhiteLink" 
                :href="shipping.active_mail_tracker_link"
                target="newTab">
              <i class="fa fa-binoculars fa-flip-horizontal" />
              Mail Tracker
              </a>
            </h5>
          </b-button>
        </div>
      </b-col>
      <!-- </b-col> -->
      <!-- </div>
      </b-col>-->
    </b-row>
    <b-row style="display: none;">
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col sm="5">
              <h4 id="traffic" class="card-title mb-0">Client Direct Order Trend</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <main-chart-example
                chartId="main-chart-01"
                class="chart-wrapper"
                style="height:300px;margin-top:40px;"
                height="300"
              ></main-chart-example>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-card style="display: none;">
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Client Direct Recipient Quantity Trend</h4>
        </b-col>
      </b-row>
      <ClientDirectRecipientTrend
        chartId="main-chart-02"
        class="chart-wrapper"
        style="height:300px;margin-top:40px;"
        height="300"
      ></ClientDirectRecipientTrend>
    </b-card>

    <!-- <b-row>
      <b-col md="12">
        <b-card header="Production and Shipping Status">
          <b-row>
            <b-col sm="12" lg="6">
              <b-row>
                <b-col sm="6">
                  <Callout variant="info">
                    <small class="text-muted">Processed</small>
                    <br />
                    <strong class="h4">9,123</strong>
                    <div class="chart-wrapper" :style="{ top: '-10px'}">
                      <callout-chart-example
                        chartId="callout-chart-01"
                        :data="[35, 23, 56, 22, 97, 23, 64]"
                        variant="info"
                        width="80"
                        height="30"
                      />
                    </div>
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="danger">
                    <small class="text-muted">Delivered</small>
                    <br />
                    <strong class="h4">8,643</strong>
                    <div class="chart-wrapper" :style="{ top: '-10px'}">
                      <callout-chart-example
                        chartId="callout-chart-02"
                        :data="[65, 59, 84, 84, 51, 55, 40]"
                        variant="danger"
                        width="80"
                        height="30"
                      />
                    </div>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0" />
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Monday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress class="progress-xs" variant="info" :value="34" height="{}" />
                  <b-progress class="progress-xs" variant="danger" :value="78" height="{}" />
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Tuesday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="56" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="94" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Wednesday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="12" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="67" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Thursday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="43" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="91" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Friday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="22" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="73" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Saturday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="53" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="82" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Sunday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="9" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="69" variant="danger"></b-progress>
                </div>
              </div>
              <div class="legend text-center">
                <small>
                  <sup>
                    <b-badge pill variant="info">&nbsp;</b-badge>
                  </sup>
                  Processed
                  &nbsp;&nbsp;
                  <sup>
                    <b-badge pill variant="danger">&nbsp;</b-badge>
                  </sup>
                  Delivered
                </small>
              </div>
            </b-col>
          </b-row>
          <br />
        </b-card>
      </b-col>
    </b-row>-->
  </div>
</template>

<script>
import CardLine1ChartExample from "./dashboard/CardLine1ChartExample";
import CardLine2ChartExample from "./dashboard/CardLine2ChartExample";
import CardLine3ChartExample from "./dashboard/CardLine3ChartExample";
import CardBarChartExample from "./dashboard/CardBarChartExample";
import MainChartExample from "./dashboard/MainChartExample";
import ClientDirectRecipientTrend from "./dashboard/ClientDirectRecipientTrend";
import SocialBoxChartExample from "./dashboard/SocialBoxChartExample";
import CalloutChartExample from "./dashboard/CalloutChartExample";
import { Callout } from "@coreui/vue";
import { mapState } from "vuex";

export default {
  name: "dashboard",
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    ClientDirectRecipientTrend
  },
  computed: {
    isAdmin: function() {
      return this.$store.state.n_user.n_current_user.IsSU;
    },
    canTrack: function() {
      return this.$store.state.n_user.n_current_user.CanTrack;
    },
    ...mapState(["shipping"]),
  },
  created() {
    this.$store.dispatch("order/getOTOrders");
    this.$store.dispatch("mcap/getMonths");
    this.$store.dispatch("shipping/get_mailtracklink");
    this.$store.dispatch("shipping/shippingMonths").then(() => {
      //alert("before mycurrentmonth");
      this.$store.state.shipping.active_month = this.$store.state.shipping.active_months.find(
        month => month.IsCurrent === true
      );
    });
  },
  data: function() {
    return {
      selected: "Month",
      tableItems: [
        {
          avatar: { url: "", status: "success" },
          user: {
            name: "ABC Client",
            new: true,
            registered: "Since 2019-03-04"
          },
          country: { name: "USA", flag: "us" },
          usage: { value: 50, period: "Mar 11, 2019 - Present" },
          payment: { name: "Mastercard", icon: "fa fa-cc-mastercard" },
          activity: "10 sec ago"
        },
        {
          avatar: { url: "", status: "danger" },
          user: {
            name: "BCD Client",
            new: false,
            registered: "Jan 1, 2015"
          },
          country: { name: "USA", flag: "us" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Visa", icon: "fa fa-cc-visa" },
          activity: "5 minutes ago"
          // },
          // {
          //   avatar: { url: "img/avatars/3.jpg", status: "warning" },
          //   user: { name: "Quintin Ed", new: true, registered: "Jan 1, 2015" },
          //   country: { name: "India", flag: "in" },
          //   usage: { value: 74, period: "Jun 11, 2015 - Jul 10, 2015" },
          //   payment: { name: "Stripe", icon: "fa fa-cc-stripe" },
          //   activity: "1 hour ago"
          // },
          // {
          //   avatar: { url: "img/avatars/4.jpg", status: "" },
          //   user: { name: "Enéas Kwadwo", new: true, registered: "Jan 1, 2015" },
          //   country: { name: "France", flag: "fr" },
          //   usage: { value: 98, period: "Jun 11, 2015 - Jul 10, 2015" },
          //   payment: { name: "PayPal", icon: "fa fa-paypal" },
          //   activity: "Last month"
          // },
          // {
          //   avatar: { url: "img/avatars/5.jpg", status: "success" },
          //   user: {
          //     name: "Agapetus Tadeáš",
          //     new: true,
          //     registered: "Jan 1, 2015"
          //   },
          //   country: { name: "Spain", flag: "es" },
          //   usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          //   payment: { name: "Google Wallet", icon: "fa fa-google-wallet" },
          //   activity: "Last week"
          // },
          // {
          //   avatar: { url: "img/avatars/6.jpg", status: "danger" },
          //   user: {
          //     name: "Friderik Dávid",
          //     new: true,
          //     registered: "Jan 1, 2015"
          //   },
          //   country: { name: "Poland", flag: "pl" },
          //   usage: { value: 43, period: "Jun 11, 2015 - Jul 10, 2015" },
          //   payment: { name: "Amex", icon: "fa fa-cc-amex" },
          //   activity: "Last week"
          //
        }
      ],
      tableFields: {
        avatar: {
          label: "Accounting Status",
          class: "text-left"
        },
        user: {
          label: "User"
        },
        country: {
          label: "Country",
          class: "text-center"
        },
        usage: {
          label: "% of Total Sales"
        },
        payment: {
          label: "Payment method",
          class: "text-center"
        },
        activity: {
          label: "Activity"
        }
      }
    };
  },
  methods: {
    variant(value) {
      let $variant;
      if (value <= 25) {
        $variant = "info";
      } else if (value > 25 && value <= 50) {
        $variant = "success";
      } else if (value > 50 && value <= 75) {
        $variant = "warning";
      } else if (value > 75 && value <= 100) {
        $variant = "danger";
      }
      return $variant;
    },
    flag(value) {
      return "flag-icon flag-icon-" + value;
    },
    DashRouteTo(_page) {
      this.$router.push(_page);
    }, 
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
